import { render } from "./LearnList.vue?vue&type=template&id=40af97de&scoped=true"
import script from "./LearnList.vue?vue&type=script&lang=js"
export * from "./LearnList.vue?vue&type=script&lang=js"

import "./LearnList.vue?vue&type=style&index=0&id=40af97de&scoped=true&lang=css"

import exportComponent from "/Users/vincentblin/Sites/ONET-WA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40af97de"]])

export default __exports__